const axios = require('axios').default;

function init() {
  const elButtons = [...document.querySelectorAll('[data-join-act-id]')];

  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function join(el) {
    axios.post(wpApiSettings.root + 'planet-company/v2/join-act/' + el.dataset.joinActId, {}, {
      headers:{
        'X-WP-Nonce': wpApiSettings.nonce
      }
    })
    .then(function (response) {
      if (response) {
        el.textContent = 'Thanks for joining!';
        location.reload();
        setTimeout(() => {
          el.dataset.joinActAction = 'unjoin';
          el.textContent = 'Unjoin this Act';
        }, "5000")
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  function unjoin(el) {
    axios.delete(wpApiSettings.root + 'planet-company/v2/join-act/' + el.dataset.joinActId, {
      headers:{
        'X-WP-Nonce': wpApiSettings.nonce
      }
    })
    .then(function (response) {
      if (response) {
        location.reload();
        el.textContent = 'Join this Act';
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  elButtons.forEach((el) => {
    el.addEventListener('click', () => {
      if (el.dataset.joinActAction === 'login') {
        setCookie('campaign_login_redirect', window.location.href, 7);
        window.location.href = '/sign-up/';
      }
      if (el.dataset.joinActAction === 'join') {
        join(el);
      }
      if (el.dataset.joinActAction === 'unjoin') {
        unjoin(el);
      }
    });
  });

}

export default {init};
